import { render, staticRenderFns } from "./ContactsSeoProfile.vue?vue&type=template&id=5c8ca7dc&"
import script from "./ContactsSeoProfile.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContactsSeoProfile.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8ca7dc')) {
      api.createRecord('5c8ca7dc', component.options)
    } else {
      api.reload('5c8ca7dc', component.options)
    }
    module.hot.accept("./ContactsSeoProfile.vue?vue&type=template&id=5c8ca7dc&", function () {
      api.rerender('5c8ca7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsSeoProfile.vue"
export default component.exports